import { EntityLabel, KPI, KPIGroup, Question, Questionnaire } from '@esg/esg-global-types';
import { apollo_client } from '../app/db_util';
import { generateUuidV4 } from '../../util/uuid';
import { MetadataError } from '@ep/error-handling';
import { GET_QUESTIONNAIRES_QUERY } from '../graphql/queries/questionnaire';

export interface QuestionnaireExtended extends Questionnaire {
  kpi_groups: Array<KPIGroup>;
  kpis: Array<KPI>;
  questions: Array<Question>;
}

// Singular and plural label for model entity.
export const questionnaire_label: EntityLabel = {
  one: 'Questionnaire',
  many: 'Questionnaires'
};

/**
 * Query all questionnaire documents from master list.
 * @param {string | undefined} id Optionally query a specific questionnaire by id.
 * @returns {Promise<Array<Questionnaire> | Questionnaire>}
 */
export const getQuestionnaires = async (
  id?: string
): Promise<Array<QuestionnaireExtended> | QuestionnaireExtended> => {
  try {
    const questionnaires: Array<QuestionnaireExtended> = await apollo_client
      .query({
        variables: {
          id: id
        },
        query: GET_QUESTIONNAIRES_QUERY,
        fetchPolicy: 'no-cache'
      })
      .then((response) => {
        return response.data.questionnaires;
      });
    return id ? questionnaires[0] : questionnaires;
  } catch (err: unknown) {
    const tracking_id: string = generateUuidV4();
    throw new MetadataError(
      err instanceof Error ? err.message : 'Error: getQuestionnaires failed on an unknown error.',
      {
        id: id
      },
      tracking_id
    );
  }
};
